import Swiper from "swiper/bundle";
import "swiper/css/bundle";

const swiper = new Swiper(".testimonials-swiper-init", {
  loop: false,

  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 20,
  centeredSlides: false,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,

  navigation: {
    nextEl: ".testimonials-right-arrow-btn",
    prevEl: ".testimonials-left-arrow-btn",
  },

  pagination: {
    el: ".testimonials-swiper-pagination",
    clickable: true,
  },

  breakpoints: {
    768: {
      slidesPerView: 1.8,
      slidesPerGroup: 1,
      spaceBetween: 30,
    },

    1440: {
      slidesPerView: 3.2,
      slidesPerGroup: 3,
      spaceBetween: 24,
    },
  },
});

document
  .querySelectorAll(
    ".testimonials-left-arrow-btn, .testimonials-right-arrow-btn",
  )
  .forEach((button) => {
    button.addEventListener("click", () => {
      button.blur();
    });
  });